/* eslint-disable  multiline-ternary, react/default-props-match-prop-types */
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback.jsx";
import PropTypes from "prop-types";

const LiaErrorBoundary = ({
	children,
	customFallbackComponent
}) => (
	<ErrorBoundary FallbackComponent={customFallbackComponent ? customFallbackComponent : ErrorFallback}>
		{children}
	</ErrorBoundary>
);

LiaErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
	customFallbackComponent: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.node
	])
};

LiaErrorBoundary.defaultProps = {
	customFallbackComponent: false
};

export default LiaErrorBoundary;
